(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Keep the hero video playing: retry when the browser blocks or delays autoplay
  const heroVideo = document.querySelector('.full-width video');
  if (heroVideo) {
    heroVideo.muted = true;
    heroVideo.playsInline = true;
    heroVideo.removeAttribute('controls');
    const tryPlay = function() {
      if (heroVideo.paused) {
        const p = heroVideo.play();
        if (p && p.catch) p.catch(function() {});
      }
    };
    // Loading screen: show how much is buffered, fade out once the video really plays
    const videoCover = document.getElementById('akyna-video-cover');
    const loaderBar = videoCover && videoCover.querySelector('.akyna-loader__bar');
    const loaderFill = document.getElementById('akyna-loader-fill');
    const loaderPct = document.getElementById('akyna-loader-pct');
    function setProgress(p) {
      if (!loaderFill) return;
      loaderBar.classList.remove('is-waiting');
      loaderFill.style.width = p + '%';
      loaderPct.textContent = String(Math.round(p)).padStart(3, '0');
    }
    function hideLoader() {
      if (!videoCover || videoCover.classList.contains('is-hidden')) return;
      setProgress(100);
      setTimeout(function() { videoCover.classList.add('is-hidden'); }, 250);
    }
    heroVideo.addEventListener('progress', function() {
      if (!heroVideo.duration || !heroVideo.buffered.length) return;
      // Playback starts long before the whole file is in, so count up towards "enough to play"
      const ahead = heroVideo.buffered.end(heroVideo.buffered.length - 1) / Math.min(heroVideo.duration, 6);
      setProgress(Math.min(95, ahead * 100));
    });
    heroVideo.addEventListener('playing', hideLoader);
    heroVideo.addEventListener('error', hideLoader);
    if (!heroVideo.paused && heroVideo.readyState >= 3) hideLoader();
    tryPlay();
    heroVideo.addEventListener('loadeddata', tryPlay);
    heroVideo.addEventListener('canplay', tryPlay);
    heroVideo.addEventListener('pause', function() {
      if (!document.hidden) setTimeout(tryPlay, 300);
    });
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) tryPlay();
    });
    ['pointerdown', 'pointerup', 'touchstart', 'touchend', 'click', 'scroll', 'wheel', 'keydown'].forEach(function(evt) {
      window.addEventListener(evt, tryPlay, { passive: true });
    });
  }

  // Sound toggle: Spotify link > mp3 file > the video's own sound
  const soundBtn = document.getElementById('akyna-sound-toggle');
  if (soundBtn) {
    const hero = soundBtn.closest('.full-width');
    const video = hero ? hero.querySelector('video') : null;
    const musicUrl = (soundBtn.dataset.music || '').trim();
    const spotifyUrl = (soundBtn.dataset.spotify || '').trim();
    const spotifyWrap = document.getElementById('akyna-spotify-wrap');
    let soundOn = false;

    function setLabel(on) {
      soundOn = on;
      soundBtn.textContent = on ? '[ Sound on ]' : '[ Sound off ]';
      soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    // Turn a Spotify share link into a Spotify URI
    let spotifyUri = null;
    const m = spotifyUrl.match(/open\.spotify\.com\/(?:intl-[a-z]+\/)?(track|album|playlist|episode)\/([A-Za-z0-9]+)/);
    if (m) spotifyUri = 'spotify:' + m[1] + ':' + m[2];
    else if (/^spotify:(track|album|playlist|episode):[A-Za-z0-9]+$/.test(spotifyUrl)) spotifyUri = spotifyUrl;

    if (spotifyUri && spotifyWrap) {
      let controller = null;
      let pendingPlay = false;
      let started = false;
      let ended = false;

      function showPlayer(show) {
        spotifyWrap.classList.toggle('is-visible', show);
        spotifyWrap.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      window.onSpotifyIframeApiReady = function(IFrameAPI) {
        IFrameAPI.createController(
          document.getElementById('akyna-spotify'),
          { uri: spotifyUri, width: '100%', height: 80 },
          function(ctrl) {
            controller = ctrl;
            ctrl.addListener('playback_update', function(e) {
              const d = e && e.data;
              if (!d) return;
              if (d.duration && d.position >= d.duration - 800) ended = true;
              // Keep the button in sync when the preview ends or is paused in the player
              if (d.isPaused && soundOn && started) { setLabel(false); showPlayer(false); }
              if (!d.isPaused && !soundOn) { setLabel(true); showPlayer(true); ended = false; }
            });
            if (pendingPlay) { pendingPlay = false; started = true; ctrl.play(); }
          }
        );
      };
      const s = document.createElement('script');
      s.src = 'https://open.spotify.com/embed/iframe-api/v1';
      s.async = true;
      document.body.appendChild(s);

      soundBtn.addEventListener('click', function() {
        if (!soundOn) {
          setLabel(true);
          showPlayer(true);
          if (!controller) { pendingPlay = true; return; }
          if (!started || ended) { started = true; ended = false; controller.play(); }
          else { controller.resume(); }
        } else {
          setLabel(false);
          showPlayer(false);
          if (controller) controller.pause();
        }
      });
    } else {
      let music = null;
      if (musicUrl) {
        music = new Audio(musicUrl);
        music.loop = true;
        music.preload = 'none';
      }
      soundBtn.addEventListener('click', function() {
        const on = !soundOn;
        if (music) {
          if (on) { music.play().catch(function() {}); } else { music.pause(); }
        } else if (video) {
          video.muted = !on;
          if (on) { video.volume = 1; video.play().catch(function() {}); }
        }
        setLabel(on);
      });
    }
  }
  
  // Amsterdam time function
  function updateAmsterdamTime() {
    const timeElement = document.getElementById('amsterdam-time');
    if (timeElement) {
      const now = new Date();
      const amsterdamTime = new Date(now.toLocaleString("en-US", {timeZone: "Europe/Amsterdam"}));
      
      const hours = amsterdamTime.getHours().toString().padStart(2, '0');
      const minutes = amsterdamTime.getMinutes().toString().padStart(2, '0');
      
      timeElement.textContent = `${hours}:${minutes}`;
    }
  }
  
  // Tokyo time function
  function updateTokyoTime() {
    const timeElement = document.getElementById('tokyo-time');
    if (timeElement) {
      const now = new Date();
      const tokyoTime = new Date(now.toLocaleString("en-US", {timeZone: "Asia/Tokyo"}));
      
      const hours = tokyoTime.getHours().toString().padStart(2, '0');
      const minutes = tokyoTime.getMinutes().toString().padStart(2, '0');
      
      timeElement.textContent = `${hours}:${minutes}`;
    }
  }
  
  // Update times immediately and then every second
  updateAmsterdamTime();
  updateTokyoTime();
  setInterval(updateAmsterdamTime, 1000);
  setInterval(updateTokyoTime, 1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
// Countdown Timer for October 10th, 2025 at 16:00 PM Amsterdam time
(function() {
  const targetDate = new Date('2025-10-31T16:00:00+02:00');
  
  function updateCountdown() {
    const now = new Date();
    const timeLeft = targetDate - now;
    
    if (timeLeft <= 0) {
      document.getElementById('days').textContent = '00';
      document.getElementById('hours').textContent = '00';
      document.getElementById('minutes').textContent = '00';
      document.getElementById('seconds').textContent = '00';
      return;
    }
    
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    
    document.getElementById('days').textContent = days.toString().padStart(2, '0');
    document.getElementById('hours').textContent = hours.toString().padStart(2, '0');
    document.getElementById('minutes').textContent = minutes.toString().padStart(2, '0');
    document.getElementById('seconds').textContent = seconds.toString().padStart(2, '0');
  }
  
  updateCountdown();
  setInterval(updateCountdown, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slides = Array.from(document.querySelectorAll('.akp-slide'));
  const indexBtns = Array.from(document.querySelectorAll('.akp-index__btn'));
  const track = document.getElementById('akp-track');
  const mobileCurrent = document.getElementById('akp-mobile-current');
  let current = 0;

  function setActive(i) {
    current = i;
    indexBtns.forEach(function(b, n) { b.classList.toggle('is-active', n === i); });
  }

  // Desktop: scroll through the images; the side index follows along
  if ('IntersectionObserver' in window && slides.length) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && window.innerWidth > 900) {
          setActive(parseInt(entry.target.dataset.index, 10));
        }
      });
    }, { threshold: 0.6 });
    slides.forEach(function(s) { observer.observe(s); });
  }

  // Click a number: scroll to that image
  indexBtns.forEach(function(b) {
    b.addEventListener('click', function() {
      const i = parseInt(b.dataset.go, 10);
      if (slides[i]) slides[i].scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActive(i);
    });
  });

  // Mobile: swipe counter
  if (track && mobileCurrent) {
    track.addEventListener('scroll', function() {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      mobileCurrent.textContent = i + 1;
      current = i;
    }, { passive: true });
  }

  // Size guide link opens the Size and fit accordion
  document.querySelectorAll('[data-open]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      const target = document.getElementById(a.dataset.open);
      if (target) { e.preventDefault(); target.open = true; target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  });

  // Variant change: update price, button and URL
  const select = document.querySelector('.akp-select');
  const priceEl = document.querySelector('.akp-price');
  if (select) {
    select.addEventListener('change', function() {
      const opt = select.options[select.selectedIndex];
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      const url = new URL(window.location);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url);
    });
  }

  // Keep product videos playing (incl. battery-saving browsers)
  const vids = document.querySelectorAll('.product-video');
  function playAll() {
    vids.forEach(function(v) {
      v.muted = true; v.playsInline = true; v.removeAttribute('controls');
      if (v.paused) { const p = v.play(); if (p && p.catch) p.catch(function() {}); }
    });
  }
  if (vids.length) {
    playAll();
    ['pointerdown', 'touchend', 'click', 'scroll', 'keydown'].forEach(function(evt) {
      window.addEventListener(evt, playAll, { passive: true });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
